import { QueryClient } from "@tanstack/react-query";
import { milliseconds } from "date-fns";

/**
 * Creates a new {@link QueryClient} with default options.
 */
export function createQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: milliseconds({ minutes: 10 }),
        gcTime: milliseconds({ minutes: 10 }),
      },
      mutations: {},
    },
  });
}
